// extracted by mini-css-extract-plugin
export default {"root":"q1Une0","counter":"XqtUu9","label":"tynUql"};